// Returns the difference between a float and the nearest integer
const distFromWhole = n => Math.abs(n - Math.round(n))

/**
 * Given an array of items of certain container values,
 * finds the item that the closest whole-number of copies can be made of
 * from a container value.
 *
 * @export
 * @class OutputRange
 */
export default class OutputRange {
	constructor(items) {
		// Sort items
		this.items = items.sort((a, b) => a.value - b.value)
	}

	getClosestItem(value) {
		// Calculate num copies of each item that could be made
		// and pick the item closest to a whole number of copies
		return this.items.reduce(
			(acc, item) => {
				const copies = value / item.value
				const dist = distFromWhole(copies)
				return copies > 0.5 && dist < acc.dist ? { item, dist } : acc
			},
			{
				item: this.items[0],
				dist: Infinity
			}
		).item
	}

	calculate(value) {
		// Get closest item
		const closest = this.getClosestItem(value)

		// Calculate number of copies of that item
		const copies = Math.max(1, Math.round(value / closest.value))

		return {
			desc: `${copies} ${closest.name}${copies === 1 ? '' : 's'}`,
			icon: closest.icon
		}
	}
}
